import React from 'react';
import { MobXProviderContext } from 'mobx-react';
import { Stores } from '../stores/initStores';

export const useStores = (): Stores => {
  return React.useContext(MobXProviderContext) as Stores;
};
